<template>
<div class="slide slide06">
    <h3 class="title">
         <div class="mo">한방병원 장기운영 캠페인</div>
        Strategy &amp; Result
    </h3>
    <span class="text">
        고객 상담 DB의 효율적 확보를 위해서 개원 이벤트 캠페인 등 온라인 통합 마케팅 운영 <br>
        이슈 인물을 활용한 캠페인 진행을 통한 주목도 증대와 키워드 광고의 지속적인 최적화를 통한, 효율 개선
    </span>
    
    <div class="tableBox">
        <table class="table" v-if="$device.windows">
            <colgroup>
                <col width="80px">
                <col width="230px">
                <col width="150px">
                <col width="130px">
                <col width="370px">
            </colgroup>
            <thead>
                <th colspan="5">장기 운영에 따른 변동 추이</th>
            </thead>
            <tbody>
                <tr class="first">
                    <td></td>
                    <td>
                        <ul>
                            <li>주요 키워드에 대한 노출의 중요성</li>
                            <li>효율적인 시간대 분석 → 집중 운영</li>
                            <li>확장 검색을 통한 잠재 고객 확보</li>
                            <li>광고지수 향상을 위한 노출 빈도</li>
                        </ul>
                    </td>
                    <td colspan="2">
                        <ul>
                            <li>PC/Mobile 효율 최적화 Mix</li>
                            <li>효율적인 신규 매체 개발</li>
                            <li>시즌별 Media, Device 운영 전략</li>
                            <li>인터넷 사용자 허들 개선 정책</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>솔루션을 활용한 키워드 확보</li>
                            <li>지칭 키워드 집중 효율관리</li>
                            <li>모바일 효율 키워드 확장</li>
                            <li>온라인 Total 최적화</li>
                        </ul>
                    </td>
                </tr>
                <tr class="two">
                    <th>Budget</th>
                    <td>3,700만원</td>
                    <td>6,300만원</td>
                    <td>6,000만원</td>
                    <td>1억원</td>
                </tr>
                <tr class="three">
                    <th>전환</th>
                    <td>215</td>
                    <td>460</td>
                    <td>780</td>
                    <td>1,420</td>
                </tr>
                <tr>
                    <th>Click</th>
                    <td>25,000</td>
                    <td>120,000</td>
                    <td>137,000</td>
                    <td>250,000</td>
                </tr>
                <tr>
                    <th>CPC</th>
                    <td>1487</td>
                    <td>532</td>
                    <td>432</td>
                    <td>400</td>
                </tr>
                <tr>
                    <th>CPA</th>
                    <td>174,000원</td>
                    <td>138,000원</td>
                    <td>76,000원</td>
                    <td>70,000원</td>
                </tr>
            </tbody>
        </table>
        <table class="motable" v-else>
            <thead>
                <th>장기 운영에 따른 변동 추이</th>
            </thead>
            <tbody>
                <tr class="first">
                    <td>
                        <img src="@/assets/images/clientSlide06Img_01.png" alt="">
                    </td>
                </tr>
                <tr class="two">
                    <td>
                        <img src="@/assets/images/clientSlide06Img_02.png" alt="">
                    </td>
                </tr>
                <tr class="three">
                    <td>
                        <img src="@/assets/images/clientSlide06Img_03.png" alt="">
                    </td>
                </tr></tbody>
        </table>
    </div>

    <div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">처음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
    methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>